import React, {useState, useContext, useEffect} from 'react';
import Spinner from '../../../Spinner';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponentNotSorted from '../../../Selects/SelectComponentNotSorted';
import SelectComponent from '../../../Selects/SelectComponent';
import MultiSelect from '../../../Selects/MultiSelect';
import {ToastContainer} from 'react-toastify';
import {useHistory, useParams} from 'react-router-dom';
import {Context} from '../../../../Helpers/Auth';
import {toast} from 'react-toastify';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

import {getProspects} from '../../../../pages/requests';
import {format} from 'date-fns';

function DadosBase({info, setOnChangeForm}) {
    const {t} = useTranslation();
    const {
        editarNegocio,
        negocio,

        loading,

        responsaveisTodos,
        setRespRV,
        respRV,
        setValidacaoResp,
        validacaoResp,

        setContas,
        contas,
        setContaR,
        contaR,
        setValidacaoConta,
        validacaoConta,

        setDivisaR,
        setValidacaoDivisa,

        estabelecimentos,
        setEstabR,
        estabR,
        setValidacaoEstab,
        ValidacaoEstab,

        setDenominacao,
        denominacao,
        setValidacaoDenominacao,
        validacaoDenominacao,

        contactos,
        setContactoR,
        contactoR,
        setValidacaoContacto,
        validacaoContacto,

        setStartDate,
        startDate,
        setValidacaoStartDate,
        validacaoStartDate,

        probabilidadeFiltros,
        setProbabilidadeNegocioR,
        probabilidadeNegocioR,
        setValidacaoProbNeg,
        validacaoProbNeg,

        origens,
        setOrigem,
        origem,
        setValidacaoOrigem,
        validacaoOrigem,

        setObservacoes,
        observacoes,
        setValidacaoObservacoes,

        setContratoManutencao,
        contratoManutencao,

        setContratoFinanceiro,
        contratoFinanceiro,
    } = info;

    const FORMATO_DATA = 'YYYY-MM-DD';

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }
    function GetContas(pesquisa) {
        if (pesquisa.length >= 3) {
            getProspects(0, 9999, lang, pesquisa, '', '', '', '').then(res => {
                setContas(
                    res.data.clientes.map(c => {
                        return {
                            ...c,
                            value: c.codigoCliente,
                            label: c.nomeCliente,
                        };
                    }),
                );
            });
        } else {
            setContas([]);
        }
    }

    return (
        <>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {!loading && (
                <form className="mt-4">
                    <div className="grid gap-6 mb-3 md:grid-cols-3">
                        <div>
                            <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('representante')}*
                            </label>
                            <SelectComponent
                                options={responsaveisTodos}
                                value={respRV}
                                onChange={e => {
                                    setRespRV(e);
                                    setOnChangeForm(true);
                                    setValidacaoResp(false);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                                isDisabled={!editarNegocio}
                            />
                            {validacaoResp && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('contaCliente')}*
                            </label>
                            <SelectComponent
                                options={contas}
                                value={contaR}
                                onChange={e => {
                                    setValidacaoConta(false);
                                    setOnChangeForm(true);
                                    setContaR(e);
                                    if (e.divisa) {
                                        setDivisaR(e.divisa);
                                        setValidacaoDivisa(false);
                                    }
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('pesquisa')}
                                isDisabled={!editarNegocio}
                                onInputChange={e => GetContas(e)}
                            />
                            {validacaoConta && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                        <div>
                            <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('estabelecimentoVenda')}*
                            </label>
                            <SelectComponent
                                options={estabelecimentos}
                                value={estabR}
                                onChange={e => {
                                    setEstabR(e);
                                    setOnChangeForm(true);
                                    setValidacaoEstab(false);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                                isDisabled={!editarNegocio}
                            />
                            {ValidacaoEstab && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                    </div>

                    <div className="grid gap-6 mb-3 md:grid-cols-2">
                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('denominacao')}*
                            </label>

                            <input
                                type="text"
                                // defaultValue={nomeF}
                                value={denominacao}
                                className={` border cursor-not-allowed border-gray-300 bg-gray-50 dark:bg-gray-800 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    validacaoDenominacao ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                }                                                `}
                                onChange={e => {
                                    setDenominacao(e.target.value);
                                    setValidacaoDenominacao(false);
                                    setOnChangeForm(true);
                                }}
                                required
                                disabled={true}
                            />
                        </div>
                        <div>
                            <label htmlFor="phone" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white `}>
                                {t('contacto')}*
                            </label>
                            <MultiSelect
                                isDisabled={!editarNegocio}
                                options={contactos}
                                value={contactoR}
                                onChange={e => {
                                    setOnChangeForm(true);
                                    setContactoR(e);
                                    setValidacaoContacto(false);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                            />
                            {validacaoContacto && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                    </div>

                    <div className="grid gap-6 mb-3 md:grid-cols-2">
                        <div>
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('dataEstimadaFecho')}*
                            </label>
                            <Datepicker
                                displayFormat={FORMATO_DATA}
                                useRange={false}
                                asSingle={true}
                                value={startDate}
                                onChange={newValue => {
                                    setStartDate(newValue);
                                    setOnChangeForm(true);
                                    setValidacaoStartDate(false);
                                }}
                                inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    !editarNegocio ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                } `}
                                disabled={!editarNegocio}
                            />
                            {validacaoStartDate && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                    </div>
                    <div className="grid gap-3 mb-3 md:grid-cols-2">
                        <div>
                            <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('probabilidade')}*
                            </label>
                            <SelectComponent
                                options={probabilidadeFiltros}
                                value={probabilidadeNegocioR}
                                onChange={e => {
                                    setProbabilidadeNegocioR(e);
                                    setOnChangeForm(true);
                                    setValidacaoProbNeg(false);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                                isDisabled={!editarNegocio}
                            />
                            {validacaoProbNeg && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>

                        <div>
                            <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('origem')}*
                            </label>
                            <SelectComponent
                                options={origens}
                                value={origem}
                                onChange={e => {
                                    setOrigem({value: e.value, label: e.label});
                                    setOnChangeForm(true);
                                    setValidacaoOrigem(false);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                                isDisabled={!editarNegocio}
                            />
                            {validacaoOrigem && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('observacoes')}
                        </label>
                        <textarea
                            disabled={!editarNegocio}
                            id="message"
                            rows="1"
                            maxLength={250}
                            value={observacoes}
                            onChange={e => {
                                setOnChangeForm(true);
                                setObservacoes(e.target.value);
                                setValidacaoObservacoes(false);
                            }}
                            className={`block p-2.5 w-full text-sm text-gray-900  rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ${
                                !editarNegocio ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                            }`}
                            placeholder={t('escrevaObs')}></textarea>
                    </div>
                    <div className="flex-col mb-4">
                        <div>
                            <label className="relative mt-2 inline-flex items-center cursor-pointer">
                                <input type="checkbox" checked={contratoManutencao} onChange={() => setContratoManutencao(!contratoManutencao)} className="sr-only peer" disabled={!editarNegocio} />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('temContratoManutencao')}</span>
                            </label>
                        </div>
                        <div>
                            <label className="relative mt-2 inline-flex items-center cursor-pointer">
                                <input type="checkbox" onChange={() => setContratoFinanceiro(!contratoFinanceiro)} checked={contratoFinanceiro} className="sr-only peer" disabled={!editarNegocio} />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('temContratoFinanceiro')}</span>
                            </label>
                        </div>
                    </div>
                </form>
            )}
            <ToastContainer />
        </>
    );
}

export default DadosBase;
